import IconButton from '@material-ui/core/IconButton'
import styled from 'styled-components'

export const StyledButton = styled.a<{
  $size?: string
  $type?: string
  $alignment?: string
  $icon?: boolean
  $buttonTheme: string
  $useCase: string
}>`
  && {
    ${({ theme, $size, $type, $alignment, $icon, $buttonTheme, $useCase }: any) => {
      let typeStyles, sizeStyles, alignmentStyles, paddingStyles
      if ($size === 'large') {
        sizeStyles = `
          height: 64px;
        `
      }

      if ($size === 'medium') {
        sizeStyles = `
          height: 56px;
        `
      }

      if ($size === 'small') {
        sizeStyles = `
          height: 48px;
        `
      }

      if ($type === 'primary') {
        if ($buttonTheme === 'light') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.light.primary};
            color: ${theme.webMktNewPalette.white};

            &:hover {
              background: ${theme.webMktNewPalette.button.light.primaryHover};
              color: ${theme.webMktNewPalette.white};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.light.primaryPressed};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.white};
                }
              }
            }
          `
        }

        if ($buttonTheme === 'dark') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.dark.primary};
            color: ${theme.webMktNewPalette.white};

            &:hover {
              background: ${theme.webMktNewPalette.button.dark.primaryHover};
             

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.dark.primaryPressed};
             

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                   
                  }
                }
              }
            }

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.white};
                }
              }
            }
          `
        }

        if ($buttonTheme === 'orange') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.colored.primary};
            color: ${theme.webMktNewPalette.black};

            &:hover {
              background: ${theme.webMktNewPalette.button.colored.primaryHover};
              color: ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.colored.primaryPressed};
              color: ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.black};
                }
              }
            }
          `
        }
      }

      if ($type === 'secondary') {
        if ($buttonTheme === 'light') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.light.secondary};
            color: ${theme.webMktNewPalette.white};

            &:hover {
              background: ${
                $useCase === 'Pricing'
                  ? theme.webMktNewPalette.deepBlue[15]
                  : theme.webMktNewPalette.button.light.secondaryHover
              };
              color: ${theme.webMktNewPalette.white};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.light.secondaryPressed};
              color: ${theme.webMktNewPalette.white};
              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.white};
                }
              }
            }
          `
        }

        if ($buttonTheme === 'dark') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.dark.secondary};
            color: ${theme.webMktNewPalette.black};

            &:hover {
              background: ${theme.webMktNewPalette.button.dark.secondaryHover};
              color: ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.dark.secondaryPressed};
              color: ${theme.webMktNewPalette.black};
              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }
          `
        }
      }

      if ($type === 'tertiary') {
        if ($buttonTheme === 'light') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.light.tertiary};
            color: ${theme.webMktNewPalette.black};
            border: 2px solid ${theme.webMktNewPalette.black};

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.black};
                }
              }
            }

            &:hover {
              background: ${theme.webMktNewPalette.button.light.tertiaryHover};
              color: ${theme.webMktNewPalette.black};
              border: 2px solid ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.light.tertiaryPressed};
              color: ${theme.webMktNewPalette.black};
              border: 2px solid ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }
          `
        }

        if ($buttonTheme === 'dark' || $buttonTheme === 'orange') {
          typeStyles = `
            background: ${theme.webMktNewPalette.button.dark.tertiary};
            color: ${theme.webMktNewPalette.white};
            border: 2px solid ${theme.webMktNewPalette.white};

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.white};
                }
              }
            }

            &:hover {
              background: ${theme.webMktNewPalette.button.dark.tertiaryHover};
              color: ${theme.webMktNewPalette.white};
              border: 2px solid ${theme.webMktNewPalette.white};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }

            &:active {
              background: ${theme.webMktNewPalette.button.dark.tertiaryPressed};
              color: ${theme.webMktNewPalette.white};
              border: 2px solid ${theme.webMktNewPalette.white};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.white};
                  }
                }
              }
            }
          `
        }
      }

      if ($alignment === 'center') {
        alignmentStyles = `
          text-align: center;
          padding-left: 32px;
          padding-right: 32px;
        `
      }

      if ($alignment === 'left' && !$icon) {
        alignmentStyles = `
          text-align: left;
          padding-right: 64px;
        `
      }

      if ($icon) {
        alignmentStyles = `
          text-align: left;
          padding-right: 24px;
        `

        paddingStyles = `
          padding: 12px 12px 12px 24px;
        `
      } else {
        paddingStyles = `
          padding: 12px 24px;
        `
      }

      const inlineTextLinkStyles = `
        color: ${
          $buttonTheme === 'dark'
            ? theme.webMktPalette.icon.blueDark
            : theme.webMktPalette.icon.blueLight
        };

        text-decoration: none;
        position: relative;
        display: inline-block;
        position: relative;
        font-weight: 400;

        span {
          vertical-align: bottom;
        }

        .CTA__Arrow-Container {
          display: none;
        }

        &:hover {
          color: ${
            $buttonTheme === 'dark'
              ? theme.webMktPalette.icon.blueDark
              : theme.webMktPalette.icon.blueLight
          };

          span {
            border-bottom: 2px solid;
            width: calc(100% - 40px);
          }
        }

        &:focus {
          color: ${
            $buttonTheme === 'dark' ? theme.webMktPalette.icon.blueDark : `rgb(0 103 223 / .5)`
          };
        }
      `

      const buttonStyles = `
        transition: 0.1s all cubic-bezier(0.4, 0.0, 0.2, 1);
        border-radius: 0;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        ${paddingStyles}
        ${typeStyles}
        ${sizeStyles}
        ${alignmentStyles}

        .CTA__Icon {
          width: 24px;
          height: 24px;
        }

        &:hover {
          text-decoration: none;
        }

        display: inline-flex;
        flex-direction: row;
        align-items: center;
      `

      const textLinkStyles = `
        color: ${
          $buttonTheme === 'dark'
            ? theme.webMktPalette.icon.blueDark
            : theme.webMktPalette.icon.blueLight
        };

        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        text-decoration: none;
        position: relative;
        display: inline-block;
        position: relative;

        span {
          vertical-align: bottom;
        }

        .CTA__Arrow-Container {
          display: inline;
          &:before {
            content: "\\E919";
            font-family: "Icons-Essentials";
            font-size: 24px;
            font-weight: 400;
            vertical-align: bottom;
          }
        }

        ${
          $useCase === 'formFlex'
            ? `
          display: flex; 
          span {
            order: 2;
          }
          .CTA__Arrow-Container {
            order: 1;
            margin-left: 0px;
            margin-right: 16px;
          }
        `
            : ''
        }

        &:hover {
          color: ${
            $buttonTheme === 'dark'
              ? theme.webMktPalette.icon.blueDark
              : theme.webMktPalette.icon.blueLight
          };

          span {
            border-bottom: 2px solid;
            width: calc(100% - 40px);
          }
        }

        &:focus {
          color: ${
            $buttonTheme === 'dark' ? theme.webMktPalette.icon.blueDark : `rgb(0 103 223 / .5)`
          };
        }
      `

      let typeSpecificStyles
      if ($type === 'text-link') {
        typeSpecificStyles = textLinkStyles
      } else if ($type === 'inline-text-link') {
        typeSpecificStyles = inlineTextLinkStyles
      } else {
        typeSpecificStyles = buttonStyles
      }

      return `
        font-family: "Inter", sans-serif;
        letter-spacing: 0px;
        box-sizing: border-box;
        span {
          font-family: "Inter", sans-serif;
        }
        .CTA__Icon-Container-Left {
          width: 16px;
          height: 16px;
          display: flex;
          margin-right: 8px;
          flex-direction: column;
          justify-content: center;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .CTA__Arrow-Container {
          height: 24px;
          width: 24px;
          margin-left: 16px;
        } 

        ${typeSpecificStyles}
      `
    }}
  }
`

export const StyledIconButton = styled(IconButton)<{
  $buttonTheme: string
  $arrowOrientation: string
}>`
  && {
    ${({ theme, $buttonTheme, $arrowOrientation }: any) => {
      let arrowStyles, buttonStyles

      if ($arrowOrientation === 'left') {
        arrowStyles = `
          transform: rotate(180deg);
        `
      } else {
        arrowStyles = undefined
      }

      if ($buttonTheme === 'light') {
        buttonStyles = `
          &:hover {
            background: ${theme.webMktNewPalette.alphaBlack[20]};
          }

          &:active {
            background: ${theme.webMktNewPalette.alphaBlack[20]};
            #ArrowPath {
              fill: #9D9D9D;
            }
          }
        `
      }

      if ($buttonTheme === 'dark') {
        buttonStyles = `
          &:hover {
            background: ${theme.webMktNewPalette.alphaWhite[20]};
          }

          &:active {
            background: ${theme.webMktNewPalette.alphaWhite[20]};
            #ArrowPath {
              fill: #666767;
            }
          }
        `
      }

      return `
        ${buttonStyles}
        #ArrowPath {
          fill: ${
            $buttonTheme === 'light' ? theme.webMktNewPalette.black : theme.webMktNewPalette.white
          };
        }

        .Quote__Slider-Button-Circle {
          width: 56px;
          height: 56px;
          border-radius: 100%;
          box-sizing: border-box;
          border: 2px solid ${
            $buttonTheme === 'light' ? theme.webMktNewPalette.black : theme.webMktNewPalette.white
          };
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          ${theme.breakpoints.down('md')} {
            width: 48px;
            height: 48px;
          }
          
          svg {
            ${arrowStyles}
          }
        }
      `
    }}
  }
`
